import React, { memo, useMemo } from 'react';

import EntityFormModal from '@sharedCR/common/EntityFormModal';
import PropTypes from 'prop-types';

import InteractionDrawerContent from './InteractionDrawerContent';

const InteractionDrawer = ({ isOpen, onClose, interaction, onSave }) => {
  const title = interaction ? 'Edit Interaction' : 'Log Interaction';

  const additionalProps = useMemo(() => ({ interaction, onSave }), [interaction, onSave]);

  return (
    <EntityFormModal
      isData
      isHiddenNavigationTabs
      Content={InteractionDrawerContent}
      additionalProps={additionalProps}
      isOpen={isOpen}
      title={title}
      onClose={onClose}
    />
  );
};

InteractionDrawer.propTypes = {
  isOpen: PropTypes.bool.isRequired,
  onClose: PropTypes.func.isRequired,
  onSave: PropTypes.func.isRequired,
  interaction: PropTypes.object,
};

export default memo(InteractionDrawer);
